import './brand.scss';

export default () => {

};
